import { InteractionType } from '@azure/msal-browser';
import { MsalAuthenticationTemplate } from '@azure/msal-react';
import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { ReactNotifications } from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css';
import { FeatureContextProvider } from './components/feature/featureContext';
import { Layout } from './components/layout';
import { ErrorPage } from './components/shared/error/errorPage';
import { UserDetailsContextProvider } from './services/auth/userDetailsContext';
import { DevModeContextProvider } from './services/devMode';

import './App.css';
import './css/form.css';
import './css/notify.css';


const App = () => {
    return (
        <MsalAuthenticationTemplate interactionType={InteractionType.Redirect}>
            <ErrorBoundary fallbackRender={() => <ErrorPage>An issue occurred and the app could not recover. Refresh your page and try again.</ErrorPage>}>
                <DevModeContextProvider>
                <UserDetailsContextProvider>
                <FeatureContextProvider>
                    <ReactNotifications />
                    <div className='app'>
                        <Layout />
                    </div>
                </FeatureContextProvider>
                </UserDetailsContextProvider>
                </DevModeContextProvider>
            </ErrorBoundary>
        </MsalAuthenticationTemplate>
    );
}

export default App;
